import {
  REGISTER_BEGIN,
  REGISTER_SUCCESS,
  REGISTER_FAILURE,
  SEND_VERIFICATION_LINK_TO_EMAIL_BEGIN,
  SEND_VERIFICATION_LINK_TO_EMAIL_SUCCESS,
  SEND_VERIFICATION_LINK_TO_EMAIL_FAILURE,
  TOGGLE_EMAIL_VERIFICATION_STATUS,
} from "./register.constants";

const initialstate = {
  loading: false,
  error: "",
  response: {},
  sendVerificationLink: {
    loading: false,
    error: "",
    response: "",
  },
  isEmailVerified: false,
};

export default function registerReducer(state = initialstate, action) {
  switch (action.type) {
    case REGISTER_BEGIN:
      return { ...state, loading: true };
    case REGISTER_SUCCESS:
      return {
        ...state,
        loading: false,
        response: action.payload,
      };
    case REGISTER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case SEND_VERIFICATION_LINK_TO_EMAIL_BEGIN:
      return {
        ...state,
        sendVerificationLink: {
          ...state.sendVerificationLink,
          loading: true,
        },
      };
    case SEND_VERIFICATION_LINK_TO_EMAIL_SUCCESS:
      return {
        ...state,
        sendVerificationLink: {
          ...state.sendVerificationLink,
          loading: false,
          response: action.payload,
        },
      };
    case SEND_VERIFICATION_LINK_TO_EMAIL_FAILURE:
      return {
        ...state,
        sendVerificationLink: {
          ...state.sendVerificationLink,
          loading: false,
          error: action.payload,
        },
      };
    case TOGGLE_EMAIL_VERIFICATION_STATUS:
      return {
        ...state,
        isEmailVerified: action.payload,
      };
    default:
      return state;
  }
}
